export const US_STATE = {
    AL: 'Alabama (AL)', AK: 'Alaska (AK)', AZ: 'Arizona (AZ)', AR: 'Arkansas (AR)', CA: 'California (CA)', CO: 'Colorado (CO)', CT: 'Connecticut (CT)', DE: 'Delaware (DE)',
    FL: 'Florida (FL)', GA: 'Georgia (GA)', HI: 'Hawaii (HI)', ID: 'Idaho (ID)', IL: 'Illinois (IL)', IN: 'Indiana (IN)', IA: 'Iowa (IA)', KS: 'Kansas (KS)', KY: 'Kentucky (KY)',
    LA: 'Louisiana (LA)', ME: 'Maine (ME)', MD: 'Maryland (MD)', MA: 'Massachusetts (MA)', MI: 'Michigan (MI)', MN: 'Minnesota (MN)', MS: 'Mississippi (MS)', MO: 'Missouri (MO)', MT: 'Montana (MT)',
    NE: 'Nebraska (NE)', NV: 'Nevada (NV)', NH: 'New Hampshire (NH)', NJ: 'New Jersey (NJ)', NM: 'New Mexico (NM)', NY: 'New York (NY)', NC: 'North Carolina (NC)', ND: 'North Dakota (ND)', OH: 'Ohio (OH)',
    OK: 'Oklahoma (OK)', OR: 'Oregon (OR)', PA: 'Pennsylvania (PA)', RI: 'Rhode Island (RI)', SC: 'South Carolina (SC)', SD: 'South Dakota (SD)', TN: 'Tennessee (TN)', TX: 'Texas (TX)', UT: 'Utah (UT)',
    VT: 'Vermont (VT)', VA: 'Virginia (VA)', WA: 'Washington (WA)', WV: 'West Virginia (WV)', WI: 'Wisconsin (WI)', WY: 'Wyoming (WY)'
}

export const PHONE_TYPE = {
    Mobile: 'Mobile',
    Landline: 'Landline'
}

export const LANGUAGES = {
    English: 'English',
    Spanish: 'Spanish',
    Other: 'Other',
}

export const ADDITIONAL_LANGUAGES = {
    English: 'English',
    Spanish: 'Spanish',
    Vietnamese: "Vietnamese",
    Russian: "Russian",
    Other: 'Other',
}

export const COMMUNICTAION_PREFERENCES = {
    Email: 'Email',
    Phone: 'Phone',
    Mail: 'Mail',
}

export const YES_NO = {
    Y: 'Yes',
    N: 'No'
}

export const YES_NO_TRANS_KEY = {
    Y: 'yes',
    N: 'no'
}

export const YES_NO_ST = {
    Y: 'Yes',
    N: 'No',
    T: 'Sometimes'
}

export const YES_NO_NS = {
    Y: 'Yes',
    N: 'No',
    S: 'Not Sure'
}

export const VALIDATIONS = {
    Number: {
        isZipCode: { // US zipcode
            test: /^\d{5}(?:\d{4})?$/,
            msg: 'Zip code must be either 5 or 9 digits'
        },
        isPhone: { // US phone number
            // Regex for phone number with hyphen '-', brackets '()' or dot '.'
            // test: /^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/,
            test: /^[1-9]\d{9}$/,
            msg: 'Phone number is invalid'
        }
    },
    String: {
        isName: {
            test: /^[A-Za-z]+( [A-Za-z]+)*$/,
            msg: 'Name should only have letters and no leading or trailing spaces'
        },
        isSpanishName: {
            test: /^[A-Za-zÁÉÍÓÚÑÜáéíóúñü]+(?: [A-Za-zÁÉÍÓÚÑÜáéíóúñü]+)*$/,
            msg: 'Name should only have letters and no leading or trailing spaces'
        },
        isEmail: {
            test: /^[a-zA-Z0-9._%+-]+@(?!xn--)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            msg: 'Email is invalid'
        },
        noSpecialChars: {
            // either singe or double quote allowed, no mismatched quotes, no quotes at beginning or end and not allowed with brackets
            /* eslint-disable-next-line */
            test: /^(?!['"])(?!.*['"]$)(?!.*\(["'].*\))(?!.*\(.*['"].*\))[A-Za-z0-9 ?!,:;().'"_\/\-]+$/,
            /* eslint-disable-next-line */
            msg: 'Special characters not allowed. Allowed special chars: \? \! \, \: \; \( \) \. \' \" \_ \- \/'
        },
    }
}

export const RECORD_STATUS = {
    Open: 'Open',
    Matched: 'Matched',
    Invalid: 'Invalid',
    Error: 'Error',
    New: 'New',
}

// Program type is a property of the recruitment link, not the applicant (PHAR-23). It is carried
// by the host: a first label containing the C-SNP marker (healthspring-csnp.enrolleevoice.com)
// pins C-SNP; every other host, including the original healthspring.enrolleevoice.com, is D-SNP.
export const PROGRAM_TYPE = {
    DSNP: 'DSNP',
    CSNP: 'CSNP'
};

export const PROGRAM_TYPE_HOST_MARKER = {
    csnp: PROGRAM_TYPE.CSNP
};

export const SUBMISSION_TYPE = {
    PHARO: 'P',
    External: 'E'
}

export const VALUE = {
    Min: 'min',
    Max: 'max',
}

export const CLIENT_NAME = {
    BCPT: 'BlueCarePlus Tennessee',
    VERSUM_HEALTH: 'Versum Health',
    CIGNA: 'Cigna',
    PROVIDENCE: 'Providence',
    BCBSKS: 'BlueCross BlueShield Kansas',
    CLOVER: 'Clover Health',
    HCSC: 'Health Care Service Corporation',
}

export const CLIENT_THEME = {
    BCPT: 'bcptn',
    VERSUM_HEALTH: 'versum',
    CIGNA: 'cigna',
    PROVIDENCE: 'providence',
    BCBSKS: 'bcbsks',
    CLOVER: 'clover',
    HCSC: 'hcsc',
}

export const TRACK_BASE_URLS = [
    "CLOVER",
    "PROVIDENCE",
    "BCPT",
    "CIGNA",
    "HCSC"
];

export const LOCALES = [
    { code: "en", label: "English (United States)" },
    { code: "es", label: "Español (Mexico)" },
  ];

export const LANGUAGE = {
    English: 'en',
    Spanish: 'es'
};

export const LANG_PARAM_MAP  = {
    eng: 'en',
    esp: 'es'
};

export const I18N_TO_URL_LANG = {
    en: 'eng',
    es: 'esp',
};